import React from "react";
import { useLocation } from "react-router-dom";
import SignIn from "./SignIn";
import SignUp from "./SignUp";

const AuthLogin = ({
  setIsAuthenticated,
  forceLoginDialogVisible,
  setForceLoginDialogVisible,
  loginValidate,
  setNoSessionDialogVisible,
  noSessionDialogVisible,
}) => {
  const location = useLocation();

  // Determine which component to render based on the path
  const isSignUp = location.pathname === '/become-a-customer';

  if (isSignUp) {
    return <SignUp />;
  }

  return (
    <SignIn
      setIsAuthenticated={setIsAuthenticated}
      forceLoginDialogVisible={forceLoginDialogVisible}
      setForceLoginDialogVisible={setForceLoginDialogVisible}
      loginValidate={loginValidate}
      setNoSessionDialogVisible={setNoSessionDialogVisible}
      noSessionDialogVisible={noSessionDialogVisible}
    />
  );
};

export default AuthLogin; 